export const REQUIRED = "required";
export const MIN_LENGTH = "minLength";
export const MAX_LENGTH = "maxLength";
export const MIN_VALUE = "minValue";
export const MAX_VALUE = "maxValue";
export const SITE = "site";
export const EMAIL = "email";
export const EMAILS = "emails";
export const ESPECIAL_CHARACTER = "especialCharacter";
export const NOT_NULL = "notNull";
export const URL = "url";
export const EMPTY = "empty";
